import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col span-6" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col span-6" }
const _hoisted_5 = { class: "icon icon-info" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col span-12" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col span-6" }
const _hoisted_10 = { class: "icon icon-info" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col span-6" }
const _hoisted_14 = { class: "icon icon-info" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "row" }

import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import LabeledSelect from '@shell/components/form/LabeledSelect.vue';
import Checkbox from '@components/Form/Checkbox/Checkbox.vue';
import { AuditPolicy } from '@shell/edit/auditlog.cattle.io.auditpolicy/types';
import Banner from '@components/Banner/Banner.vue';

// Component Props & Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'General',
  props: {
  value: {
    type:    Object,
    default: () => ({})
  },
  mode: {
    type:    String,
    default: 'create'
  }
},
  emits: ["update:value"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Options
const levelOptions = [0, 1, 2, 3];

// Store & i18n
const store = useStore();
const { t } = useI18n(store);

// Default Values & Reactive Spec
const defaults: AuditPolicy = {
  enabled:   false,
  verbosity: {
    level:   0, // The default level is 0, even if you set null, it will save as 0
    request: {
      headers: false,
      body:    false,
    },
    response: {
      headers: false,
      body:    false,
    }
  }
};

const spec = ref<AuditPolicy>({
  ...defaults,
  ...props.value,
  verbosity: {
    ...defaults.verbosity,
    ...props.value?.verbosity,
    request: {
      ...defaults.verbosity?.request,
      ...props.value?.verbosity?.request,
    },
    response: {
      ...defaults.verbosity?.response,
      ...props.value?.verbosity?.response,
    }
  },
});

// Emit update immediately after initializing spec
emit('update:value', { ...props.value, ...spec.value });

// Watch for changes and emit updates
watch(spec, (newSpec) => {
  const valueToEmit = { ...props.value, ...newSpec };

  emit('update:value', valueToEmit);
}, { deep: true });

// Computed Properties
const levelOptionsMap = computed(() => levelOptions.map((value) => {
  return { value, label: `${ t(`auditPolicy.general.verbosity.level.${ value }`) }` };
}));

return (_ctx: any,_cache: any) => {
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)("auditPolicy.general.enabled.title")), 1),
          _cache[6] || (_cache[6] = _createTextVNode()),
          _createVNode(Checkbox, {
            value: spec.value.enabled,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((spec.value.enabled) = $event)),
            mode: __props.mode,
            "label-key": "auditPolicy.general.enabled.checkbox",
            "data-testid": "auditPolicy-enabled"
          }, null, 8, ["value", "mode"])
        ])
      ])
    ]),
    _cache[18] || (_cache[18] = _createTextVNode()),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "spacer" }, null, -1)),
    _cache[20] || (_cache[20] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)("auditPolicy.general.verbosity.title")), 1),
          _cache[12] || (_cache[12] = _createTextVNode()),
          _createVNode(Banner, {
            class: "mt-0",
            color: "info",
            "label-key": "auditPolicy.general.verbosity.banner"
          }),
          _cache[13] || (_cache[13] = _createTextVNode()),
          _createElementVNode("h4", null, [
            _createTextVNode(_toDisplayString(_unref(t)("auditPolicy.general.verbosity.level.title")) + " ", 1),
            _withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [
              [_directive_clean_tooltip, _unref(t)('auditPolicy.general.verbosity.level.tooltip')]
            ])
          ]),
          _cache[14] || (_cache[14] = _createTextVNode()),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(LabeledSelect, {
                value: spec.value.verbosity!.level,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((spec.value.verbosity!.level) = $event)),
                label: _unref(t)('auditPolicy.general.verbosity.level.label'),
                options: levelOptionsMap.value,
                mode: __props.mode
              }, null, 8, ["value", "label", "options", "mode"])
            ])
          ]),
          _cache[15] || (_cache[15] = _createTextVNode()),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "spacer-small" }, null, -1)),
          _cache[17] || (_cache[17] = _createTextVNode()),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h4", null, [
                _createTextVNode(_toDisplayString(_unref(t)("auditPolicy.general.verbosity.request.title")) + " ", 1),
                _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
                  [_directive_clean_tooltip, _unref(t)('auditPolicy.general.verbosity.requestResponse.tooltip')]
                ])
              ]),
              _cache[7] || (_cache[7] = _createTextVNode()),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(Checkbox, {
                  value: spec.value.verbosity!.request!.headers,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((spec.value.verbosity!.request!.headers) = $event)),
                  label: _unref(t)('auditPolicy.general.verbosity.request.requestHeaders'),
                  mode: __props.mode
                }, null, 8, ["value", "label", "mode"])
              ]),
              _cache[8] || (_cache[8] = _createTextVNode()),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(Checkbox, {
                  value: spec.value.verbosity!.request!.body,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((spec.value.verbosity!.request!.body) = $event)),
                  label: _unref(t)('auditPolicy.general.verbosity.request.requestBody'),
                  mode: __props.mode
                }, null, 8, ["value", "label", "mode"])
              ])
            ]),
            _cache[11] || (_cache[11] = _createTextVNode()),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h4", null, [
                _createTextVNode(_toDisplayString(_unref(t)("auditPolicy.general.verbosity.response.title")) + " ", 1),
                _withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [
                  [_directive_clean_tooltip, _unref(t)('auditPolicy.general.verbosity.requestResponse.tooltip')]
                ])
              ]),
              _cache[9] || (_cache[9] = _createTextVNode()),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(Checkbox, {
                  value: spec.value.verbosity!.response!.headers,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((spec.value.verbosity!.response!.headers) = $event)),
                  label: _unref(t)('auditPolicy.general.verbosity.response.responseHeaders'),
                  mode: __props.mode
                }, null, 8, ["value", "label", "mode"])
              ]),
              _cache[10] || (_cache[10] = _createTextVNode()),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(Checkbox, {
                  value: spec.value.verbosity!.response!.body,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((spec.value.verbosity!.response!.body) = $event)),
                  label: _unref(t)('auditPolicy.general.verbosity.response.responseBody'),
                  mode: __props.mode
                }, null, 8, ["value", "label", "mode"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})